import { useSelector } from 'react-redux';
import { translateForCustomer } from 'utils/i18n';

import { getCustomerSelector } from 'common/selectors';
import { getVideoAttachmentsAvailableSelector } from 'components/video-box/video-attachments/selector';
import { AlternativeVideoTab } from './alternative-video-tab';
import { forwardRef } from 'react';

export const AlternativeAttachmentTab = forwardRef(
  (
    {
      id,
      active,
      tabIndex,
      'data-e2e': dataE2e,
      'aria-label': ariaLabel,
      'aria-controls': ariaControls,
      onClick,
      onKeyDown,
    },
    ref
  ) => {
    const withAttachments = useSelector(getVideoAttachmentsAvailableSelector);
    const customer = useSelector(getCustomerSelector) || {};

    return withAttachments ? (
      <AlternativeVideoTab
        ref={ref}
        id={id}
        active={active}
        data-e2e={dataE2e}
        aria-label={ariaLabel}
        aria-expanded={active}
        aria-controls={ariaControls}
        tabIndex={tabIndex}
        onClick={onClick}
        onKeyDown={onKeyDown}
      >
        {translateForCustomer('attachments', customer)}
      </AlternativeVideoTab>
    ) : null;
  }
);
